module.exports = __webpack_public_path__ + "static/media/invite.14ed2f56.png";